import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.success.surface};
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
